import { render } from "./MessageViewer.vue?vue&type=template&id=1e2ff938"
import script from "./MessageViewer.vue?vue&type=script&lang=js"
export * from "./MessageViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__